import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TermsComponent } from './terms.component';
import { CustomModalModule } from '../../component/modal/custom-modal.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TermsComponent],
  imports: [
    CommonModule,
    CustomModalModule,
    ModalModule.forRoot(),
    FormsModule
  ],
  exports: [
    TermsComponent
  ]
})
export class TermsModule { }
